import React,{Fragment} from 'react';
import NotificationSystem from 'react-notification-system';
import PropTypes from 'prop-types';
import {post,get} from "../../../server/actionsParent";
import Datetime from 'react-datetime';
import {formatDate} from "../../../server/util";
import {BeatLoader} from 'react-spinners';
import {_addNotification, _addNotificationError} from '../../../server/util';
import moment from 'moment';
import Events from '../eventSlider/events';
class EventPaymentParent extends React.Component{
    constructor(props){
        super(props)
        this.state={
            loading:false,
            schoolId:0,
            schoolYear:0,
            schoolName:'',
            parentName:'',
            eventList:[],
        }
    }
    componentWillMount=()=>{
        const {schoolId,schoolYear} = this.context.router.route.match.params;
        this.setState({
            schoolId:schoolId,
            schoolYear:schoolYear
        },()=>{
            this.bindEventList();
        });
    }
    componentDidMount() {
        this._notificationSystem = this.refs.notificationSystem;
    }
    bindEventList=()=>{
        const parent=sessionStorage.getItem('loggedInUserInfo');
        const schoolId=this.state.schoolId;
        const schoolYear=this.state.schoolYear;
        get('/getEventWithStudentsInfo?parentEmail='+parent+'&mealSchoolId='+schoolId+'&schoolYear='+schoolYear+'&currentDate='+moment().format('YYYY-MM-DD')+'&access_token=').then((response) => {
            if (!response.statusCode== 200) {
                throw Error(response.statusText);
            }
            console.log('response', response);
            return response.json();
        }).then(data => { 
            let _eventsList=data.response.events;
            let studentObj={}
            data.response.students.forEach(student=>{
                studentObj[student.userId]={...student,amount:0.00,isSelected:true};
            })
            _eventsList.forEach(event=>{
                let stuList=[]
                let isDonation=false;
                if(event.type==='Donation'){
                    isDonation=true;
                }
                event.notPaidStudentRecId.forEach(student=>{
                    let studObj={...studentObj[student]}
                    if(!isDonation){
                        studObj.amount=event.amount
                    }    
                    stuList.push(studObj)
                })
                event.studentList=stuList; 
            })    
            this.setState({eventList:_eventsList,schoolName:data.response.schoolName});        
        })
        .catch(
            (error) => {
                console.log('getMenuOrderYrMonth', error)
        })
    }
    render(){
        return(<Fragment>
            <section className="full-width clearfix">
            <NotificationSystem ref="notificationSystem"/>
            <div className='sweet-loading' style={{position: 'fixed', top: '50%', left: '48%', zIndex: '1000   '}}>
                    <BeatLoader
                        size={20}
                        color={'#ea7066'}
                        loading={this.state.loading}
                    />
                </div>
                <div className="container">
                    <div className="sectionTitle">
                    <div className="row">
                    <div className="col-md-6 col-sm-6 col-sm-6">
                        <h2 style={{width:'auto'}}>
                            <span><i className="fa fa-calendar" aria-hidden="true"></i> Event List</span>
                        </h2>
                    </div>
                    </div>
                    </div>
                    <div className="row">
                    <div className="col-md-12">
                        <Events eventList={this.state.eventList||[]} 
                        schoolObject={{schoolName:this.state.schoolName,schoolId:this.state.schoolId}} 
                        onPaymentDone={(resp)=>{
                            if(resp.status==200){           
                                _addNotification('Events payment added successfully.', this);
                                setTimeout(() =>            
                                //this.props.history.push('/parent')
                                 window.location.replace('/parent')
                                    , 3000);       
                                }else{
                                    _addNotificationError('Failed to add events payment ! Try again.', this);
                                }
                        }} 
                        showHideLoading={(value)=>{
                            this.setState({loading:value})
                        }}
                        {...this} />
                    </div>            
                    </div>
                    </div>
            </section>
        </Fragment>)
    }
}
EventPaymentParent.contextTypes = {
    router: PropTypes.object.isRequired
}
export default EventPaymentParent


// WEBPACK FOOTER //
// ./src/components/Parent/Home/eventPaymentParent.jsx